import { ApiClient } from '@callhub/shared';

// Use VITE_API_URL from environment, fallback to localhost for local dev
const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:8787';

let tokenProvider: (() => Promise<string | null>) | undefined;

export function setApiTokenProvider(provider?: () => Promise<string | null>) {
  tokenProvider = provider;
}

export const api = new ApiClient({
  baseUrl,
  getToken: async () => (tokenProvider ? tokenProvider() : null),
});
